import transactionApi from "@/api/transaction";
import registrationApi from "@/api/registrasi";
import coommonApi from "@/api/common";
import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import productApi from "@/api/product";

const defaultState = () => ({
	cart: [],
	step: 0,
	cartOne: '',
	dataProduk: [],
	dataProdukAll: [],
	product_category: [],
	dataSerial: [],
	tempSerial: [],
	registerItem: {},
	mitra: true,
	register: false,
	alertKeranjang: '',
	confirmPaymentMessage: '',
	selectedPayment: {
		text: "Tunai",
		value: "3"
	},
	dataCheckSerial: {},
	serialOwnedList: [],
	serialType: 1,
	payTotal: 0,
	responsePaymentPdf: '',
	progressBayar: false,
	serialOptionName: {},
	serialDigitalAvailable: 0,
	serialDigitalToSell: 0,
	showModalPin: false,
	alertPin: {},
	pinData: '',
});

const state = defaultState();

const getters = {
	cart() {
		return state.cart;
	},
	alertMandatory() {
		return state.alertMandatory;
	},
};

const mutations = {
	setRegisterItem(state, data) {
		state.registerItem = data
	},
	setMitra(state, data) {
		state.mitra = data
	},
	setRegister(state, data) {
		state.register = data
	},
	step_go(state, data) {
		state.step = data
	},
	step_up(state) {
		state.step++
	},
	step_down(state) {
		state.step--
	},
	reset(state) {
		Object.assign(state, defaultState());
	},
	listDataProduk(state, data) {
		data.data.map( (el) => {
			if (!state.mitra || state.register) {
				if (el.product_code == state.registerItem.code) {
					el.stock_pos = el.stock_pos - 1
				}
			}
			el['quantity'] = 1
			el['msg'] = ''
			return el;
		});
		state.dataProduk = data.data.sort((a,b) => b.stock_pos - a.stock_pos);
		state.dataProdukAll = data.data;
		state.pagination = data.pagination;
	},
	cariProduk(state, param) {
		let data = state.dataProdukAll.filter( (el) => {
			let category = param.category ? el.product_category_id == param.category : true;
			let value = el.product_name.toString().toLowerCase().search(param.value.toString().toLowerCase())
			el.quantity = 1
			el.msg = ''
			return category && value > -1
		})
		if (data.length == 0) {
			state.dataProduk = 'error'
		} else {
			state.dataProduk = data
		}

	},
	listDataCategory(state, data) {
		var allCategory = {
			product_category_name : 'Semua Kategori',
			product_category_id : ''
		}
		data.unshift(allCategory)
		var category = data.map( (el) => {
			let data = {
				text : el.product_category_name,
				value : el.product_category_id
			}
			return data
		})
		state.product_category = category;
	},
	setSerialOwnedList(state, data) {
		state.serialOwnedList = data
	},
	async setDataCheckSerial(state, data) {
		var serial = await state.dataSerial
		data.serial_valid.forEach( (el) => {
			let serialInclude = []
			serial.forEach(el => {
				serialInclude = [...serialInclude , ...el.serial]
			})
			let index_serial = serial.findIndex(element => element.type == el.type && element.serial.length < element.max_qty)
			if (index_serial != -1) {
				if (!serialInclude.includes(el.serial)) {
					serial[index_serial].serial.push(el.serial)
				} else {
					state.alertKeranjang = `Serial ${el.serial} sudah digunakan`
				}
			} else {
				let index_type_match = serial.findIndex(element => element.type == el.type)
				if (index_type_match == -1) {
					state.alertKeranjang = `Tidak ditemukan produk yang sesuai`
				} else {
					state.alertKeranjang = `Serial yang dibutuhkan sudah mencukupi`
				}
			}
		});
		if (data.serial_valid.length == 0) {
			state.alertKeranjang = 'Serial tidak tersedia'
		}
		state.dataSerial = await serial
	},
	setDataSerial(state, data) {
		state.dataSerial = data
	},
	setSerialType(state, data) {
		state.serialType = data
	},
	addQtyProduct(state, index) {
		state.dataProduk[index].quantity++
	},
	minQtyProduct(state, index) {
		state.dataProduk[index].quantity--
	},
	setCart(state, cartData) {
		state.cart = cartData;
	},
	addQtyCart(state, index) {
		state.cart[index].quantity++
	},
	minQtyCart(state, index) {
		state.cart[index].quantity--
	},
	resetQty(state, index) {
		state.dataProduk[index].quantity = 1
	},
	setAlert(state, data) {
		state.dataProduk[data.index].msg = data.data
	},
	setAlertKeranjang(state, data) {
		state.alertKeranjang = data
	},
	setConfirmPaymentMessage(state, data) {
		state.confirmPaymentMessage = data
	},
	removeSelected(state, data) {
		var serial = [...state.dataSerial]
		const indexSerial = serial.findIndex(el => el.product_code == data.indexType && el.type == data.type)
		data.serial.forEach( function(element) {
			const indexSerialSelected = serial[indexSerial].serialSelected.findIndex(el => el == element)
			if (indexSerialSelected != -1) {
				serial[indexSerial].serialSelected.splice(indexSerialSelected, 1)
			}
			const indexData = serial[indexSerial].serial.findIndex(el => {
				return el == element
			})
			if (indexData != -1) {
				serial[indexSerial].serial.splice(indexData, 1)
			}
		});
		// if (serial[indexSerial].serial.length == serial[indexSerial].serialSelected.length) {
		// 	serial[indexSerial].removeAll = true
		// } else {
		// 	serial[indexSerial].removeAll = false
		// }
		state.dataSerial = serial;
	},
	async checkSelected(state, data) {
		var serial = await [...state.dataSerial]
		const indexSerial = await serial.findIndex(el => el.product_code == data.index && el.type == data.type)
		if (serial[indexSerial].serialSelected.length == serial[indexSerial].serial.length) {
			serial[indexSerial].removeAll = await true
		} else {
			serial[indexSerial].removeAll = await false
		}
		state.dataSerial = await serial;
	},
	removeAll(state, data) {
		var serial = [...state.dataSerial]
		const indexSerial = serial.findIndex(el => el.product_code == data.index && el.type == data.type)
		if (data.value) {
			serial[indexSerial].serialSelected = serial[indexSerial].serial
		} else {
			serial[indexSerial].serialSelected = []
		}
		state.dataSerial = serial;
	},
	setPayment(state, data) {
		state.selectedPayment = data
	},
	setPayTotal(state, data) {
		state.payTotal = data
	},
	saveResponse(state, data) {
		state.responsePaymentPdf = data
	},
	bayarProgress(state, data) {
		state.progressBayar = data
	},
	setSerialCarton(state, data) {
		var serial = [...state.dataSerial]
		data.forEach( function(element) {
			const indexserial = serial.findIndex(el => {
				return el.product_code == element.code && el.type == element.type
			})
			serial[indexserial]['serial_carton'] = element.serial
		});
		state.dataSerial = serial;
	},
	addRegisterItem(state, data) {
		let tempCart = []
		if (state.cart) {
			tempCart = [...state.cart]
		}
		let indexProduct = tempCart.findIndex(x => x.product_id == data.product_id)
		if (indexProduct < 0) {
			tempCart.push(data)
		}
		state.cart = tempCart
	},
  setOptionSerialName(state, data) {
    state.serialOptionName = data
  },
	setSerialDigitalAvailable(state, data) {
		state.serialDigitalAvailable = data.data.available
	},
	setSerialDigitalToSell(state, data) {
		state.serialDigitalToSell = data
	},
	setShowModalPin(state, data) {
		state.showModalPin = data
	},
	setAlertPin(state, data) {
		state.alertPin = data
	},
	setPinData(state, data) {
		//console.log('mutation setPinData', data)
		state.pinData = data
	}
};

const actions = {
	getDataProduk({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		productApi.getDataProduct(param).then(({ data: { data } }) => {
			commit("listDataProduk", { data: data.results, pagination: data.pagination });
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getDataCategory({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		productApi.getDataCategory(param).then(({ data: { data } }) => {
			commit("listDataCategory", data.results );
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	changeProductQty({commit, state}, data) {
		if (data.type == 'plus') {
			const indexCart = state.cart.findIndex(el => {
				return el.product_code == state.dataProduk[data.index].product_code
			})
			var alert = ''
			if (indexCart > -1) {
				if (state.dataProduk[data.index].quantity >= (parseInt(state.dataProduk[data.index].stock_pos) - parseInt(state.cart[indexCart].quantity))) {
					alert = `Sisa Stok ${parseInt(state.dataProduk[data.index].stock_pos) - parseInt(state.cart[indexCart].quantity)}`
				}
			} else {
				if (parseInt(state.dataProduk[data.index].quantity) >= parseInt(state.dataProduk[data.index].stock_pos)) {
					alert =`Sisa Stok ${parseInt(state.dataProduk[data.index].stock_pos)}`
				}
			}
			if (alert) {
				commit('setAlert', {data: alert, index: data.index})
			} else {
				commit('addQtyProduct', data.index)
				commit('setAlert', {data: '', index: data.index})
			}
		} else if (data.type == 'min') {
			if (parseInt(state.dataProduk[data.index].quantity) > 0) {
				commit('minQtyProduct', data.index)
				commit('setAlert', {data: '', index: data.index})
			} else {
				commit('setAlert', {data: 'Minimal 1', index: data.index})
			}
		}

	},
	changeCartQty({commit, state}, data) {
		let tempCart = [...state.cart]
		if (data.type == 'plus') {
			if (parseInt(tempCart[data.index].quantity) < parseInt(tempCart[data.index].stock_pos)) {
				commit('addQtyCart', data.index)
			}
		} else if (data.type == 'min') {
			if (parseInt(tempCart[data.index].quantity) > 1) {
				commit('minQtyCart', data.index)
			} else {
				tempCart.splice(data.index, 1)
				commit('setCart', tempCart)
			}
		}
		commit('setCart', tempCart)
	},
	saveCart({ commit, state }, data) {
		let tempCart = []
		state.alerts = '';
		if (state.cart) {
			tempCart = [...state.cart]
		}
		let indexProduct = tempCart.findIndex(x => x.product_id == data.product.product_id)
		var alert = {
			data: '',
			index: data.index
		}
		if (indexProduct < 0) {
			if ((parseInt(data.product.quantity) > 0)) {
				if ((parseInt(data.product.quantity) <= parseInt(data.product.stock_pos))) {
					tempCart.push(data.product)
					commit('setAlert', alert)
					commit('resetQty', data.index)
				} else {
					alert = {
						data: 'Sisa Stok ' + parseInt(data.product.stock_pos),
						index: data.index
					}
					commit('setAlert', alert)
				}
			}
		} else {
			let total_product_qty = parseInt(tempCart[indexProduct].quantity) + parseInt(data.product.quantity);
			if (total_product_qty <= parseInt(tempCart[indexProduct].stock_pos)) {
				tempCart[indexProduct].quantity = total_product_qty
				commit('setAlert', alert)
				commit('resetQty', data.index)
			} else {
				alert = {
					data: `Sisa Stok ${parseInt(data.product.stock_pos) - parseInt(tempCart[indexProduct].quantity)}`,
					index: data.index
				}
				commit('setAlert', alert)
			}
		}
		commit('setCart', tempCart)
	},
	deleteCart({commit}, data) {
		let tempCart = [...state.cart]
		let indexProduct = tempCart.findIndex(x => x.product_id == data)
		tempCart.splice(indexProduct, 1)
		commit('setCart', tempCart)
	},
	postTransactionMitra( {commit}, data ) {
		commit(PROGRESS_START, null, { root: true });
		commit('bayarProgress', true)
		transactionApi.transaksiMitra(data).then(({ data }) => {
			if (data.code == 200) {
				commit('saveResponse', data.data.download_pdf)
				commit('step_up');
			} else {
				commit('setAlertKeranjang', 'Pembayaran gagal dilakukan')
			}
			commit('bayarProgress', false)
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch((err) => {
			const { data } = err.response
			if (data) {
				commit('setAlertKeranjang', data.message)
			} else {
				commit('setAlertKeranjang', 'Pembayaran gagal dilakukan. Periksa Kembali koneksi anda')
			}
			commit('bayarProgress', false)
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	postTransactionNonMitra( {commit}, data ) {
		commit(PROGRESS_START, null, { root: true });
		commit('bayarProgress', true)
		transactionApi.transaksiMitraBaru(data).then(({ data }) => {
			if (data.code == 200) {
				commit('saveResponse', data.data.download_pdf)
				commit('step_up');
			} else {
				commit('setAlertKeranjang', 'Pembayaran gagal dilakukan')
			}
			commit('bayarProgress', false)
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(({ response : { data } }) => {
			commit('setAlertKeranjang', data.message)
			commit('bayarProgress', false)
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	postTransactionRegister( {commit}, data ) {
		commit(PROGRESS_START, null, { root: true });
		commit('bayarProgress', true)
		registrationApi.registrasiFromStockist(data).then(({ data }) => {
			if (data.code == 200) {
				commit('saveResponse', data.data.download_pdf)
				commit('step_up');
			} else {
				commit('setAlertKeranjang', 'Pembayaran gagal dilakukan')
			}
			commit('bayarProgress', false)
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(({ response : { data } }) => {
			commit('setAlertKeranjang', data.message)
			commit('bayarProgress', false)
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	async getregisterItem({commit, dispatch}) {
		commit(PROGRESS_START, null, { root: true });
		await transactionApi.registerItem().then(({ data: { data } }) => {
			commit("setRegisterItem", data);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(({response}) => {
			if (response.status !== 406) {
				dispatch('getregisterItem');
			}
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	formatSerialString({commit}, serial) {
		var serial_value = serial.map( el => {
			var serial = {
				serial: el.serial,
				code: el.product_code,
        type: el.type
			}
			return serial
		})
		let parameterObject = {}
		let parameter = "{"
		serial_value.forEach((value, index) => {
			for (const [key, val] of Object.entries(value)) {
				parameter += `"serial[${index}][${key}]":"${encodeURI(val)}",`;
			}
		});
		parameter = parameter.slice(0, -1);
		parameter += "}";
		parameterObject = JSON.parse(parameter);
		commit(PROGRESS_START, null, { root: true });
		transactionApi.formatSerialString(parameterObject).then(({ data: { data } }) => {
			commit('setSerialCarton', data.results)
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	getSerialOwnedList({ commit }, value) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			transactionApi.dataSerial(value).then(({ data: { data } }) => {
				commit("setSerialOwnedList", data.results);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve()
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err)
				const { data } = err.response;
				commit('setAlertKeranjang', data.message)
			});
		})
	},
	checkSerialMLM({ commit }, value) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			transactionApi.checkSerialMLM(value).then(({ data: { data } }) => {
				commit("setDataCheckSerial", data.results);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve(data)
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err)
				const { data } = err.response;
				commit('setAlertKeranjang', data.message)
			});
		})
	},
	getOptionSerialName({ commit }, value) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			coommonApi.getOptionSerialName(value).then(({ data: { data } }) => {
				commit("setOptionSerialName", data);
				commit(PROGRESS_FINISH, null, { root: true });
				resolve(data)
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err)
				const { data } = err.response;
				commit('setAlertKeranjang', data.message)
			});
		})
	},
	getSerialDigitalAvailable({ commit , param}) {
		commit(PROGRESS_START, null, { root: true });
		transactionApi.getSerialDigitalAvailable(param).then(({ data: { data } }) => {
			commit("setSerialDigitalAvailable", { data: data });
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	async checkPinTransaction( {commit}, data ) {
		commit(PROGRESS_START, null, { root: true });
		await transactionApi.checkPinTransaction(data).then(({ data }) => {
			//console.log('data code', data.code)
			const code = data.code
			commit('setPinData', code)
			commit('setAlertPin', {})
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(({ response : { data } }) => {
			//console.log('catch', data.data)
			commit('setPinData', '')
			commit('setAlertPin', data.data)
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
}

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};
